[
  {
    "display": "true",
    "ui_columnname": "action",
    "db_columnname": "modifiedFlag",
    "datatype": "char",
    "mappingkey": "modifiedFlag",
    "dropdown": "NO",
    "isdefault": "false",
    "disabled": "true",
    "value": "",
    "dropdowntype": "singleselect",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Exception",
    "db_columnname": "Exception",
    "datatype": "String",
    "mappingkey": "exception_description",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Exception ID",
    "db_columnname": "OrderExceptionID",
    "datatype": "String",
    "mappingkey": "OrderExceptionID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Ord Date Time",
    "db_columnname": "OrderDateTime",
    "datatype": "String",
    "mappingkey": "OrderDateTime",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Order ID",
    "db_columnname": "oe.orderID",
    "datatype": "String",
    "mappingkey": "OrderID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Symbol",
    "db_columnname": "Symbol",
    "datatype": "String",
    "mappingkey": "Symbol",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Side",
    "db_columnname": "BuySellCode",
    "datatype": "String",
    "mappingkey": "BuySellCode",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "OrdQty",
    "db_columnname": "Quantity",
    "datatype": "String",
    "mappingkey": "Quantity",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Ord Price",
    "db_columnname": "LimitPrice",
    "datatype": "String",
    "mappingkey": "LimitPrice",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trd Date Time",
    "db_columnname": "TradeDateTime",
    "datatype": "String",
    "mappingkey": "TradeDateTime",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "TrdQty",
    "db_columnname": "TradeQuantity",
    "datatype": "String",
    "mappingkey": "TradeQuantity",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "TrdPrice",
    "db_columnname": "TradePrice",
    "datatype": "String",
    "mappingkey": "TradePrice",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Ord Bid",
    "db_columnname": "OrdBid",
    "datatype": "String",
    "mappingkey": "OrdBid",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Ord Ask",
    "db_columnname": "OrdAsk",
    "datatype": "String",
    "mappingkey": "OrdAsk",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trd Bid",
    "db_columnname": "TrdBid",
    "datatype": "String",
    "mappingkey": "TrdBid",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "TrdAsk",
    "db_columnname": "TrdAsk",
    "datatype": "String",
    "mappingkey": "TrdAsk",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Status",
    "db_columnname": "Status",
    "datatype": "String",
    "mappingkey": "Status",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Owner",
    "db_columnname": "Owner",
    "datatype": "String",
    "mappingkey": "Owner",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Comments",
    "db_columnname": "Comments",
    "datatype": "String",
    "mappingkey": "Comments",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Price Type",
    "db_columnname": "PriceType",
    "datatype": "String",
    "mappingkey": "PriceType",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Stop Price",
    "db_columnname": "StopPrice",
    "datatype": "String",
    "mappingkey": "StopPrice",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Contra ID",
    "db_columnname": "ContraID",
    "datatype": "String",
    "mappingkey": "ContraID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Contra Acct",
    "db_columnname": "ContraAcct",
    "datatype": "String",
    "mappingkey": "ContraAcct",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trader Account",
    "db_columnname": "TraderAccount",
    "datatype": "String",
    "mappingkey": "TraderAccount",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "TIF",
    "db_columnname": "TimeInForce",
    "datatype": "String",
    "mappingkey": "TimeInForce",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Expiry Date",
    "db_columnname": "ExpiryDate",
    "datatype": "String",
    "mappingkey": "ExpiryDate",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Expiry Time",
    "db_columnname": "ExpiryTime",
    "datatype": "String",
    "mappingkey": "ExpiryTime",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Locate Info",
    "db_columnname": "LocateInfo",
    "datatype": "String",
    "mappingkey": "LocateInfo",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Acct. Restrict",
    "db_columnname": "Acct.Restrict",
    "datatype": "String",
    "mappingkey": "Acct.Restrict",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Not Held",
    "db_columnname": "NotHeld",
    "datatype": "String",
    "mappingkey": "NotHeld",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "DNR/DNI",
    "db_columnname": "DoNotReduceIncrease",
    "datatype": "String",
    "mappingkey": "DoNotReduceIncrease",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "AON",
    "db_columnname": "AllOrNone",
    "datatype": "String",
    "mappingkey": "AllOrNone",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Spl. Handling Code",
    "db_columnname": "SplHandlingCode",
    "datatype": "String",
    "mappingkey": "SplHandlingCode",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Delivery Instructions",
    "db_columnname": "DeliveryInstructions",
    "datatype": "String",
    "mappingkey": "DeliveryInstructions",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Trade Along",
    "db_columnname": "TradeAlong",
    "datatype": "String",
    "mappingkey": "TradeAlong",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Limit Order Display",
    "db_columnname": "LimitOrderDisplay",
    "datatype": "String",
    "mappingkey": "LimitOrderDisplay",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Program Trading",
    "db_columnname": "ProgramTrading",
    "datatype": "String",
    "mappingkey": "ProgramTrading",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Negotiated Trade",
    "db_columnname": "NegotiatedTrade",
    "datatype": "String",
    "mappingkey": "NegotiatedTrade",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Strategy",
    "db_columnname": "Strategy",
    "datatype": "String",
    "mappingkey": "Strategy",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Strategy Details",
    "db_columnname": "StrategyDetails",
    "datatype": "String",
    "mappingkey": "StrategyDetails",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Order Desk",
    "db_columnname": "OrderDesk",
    "datatype": "String",
    "mappingkey": "OrderDesk",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Originating Desk",
    "db_columnname": "OriginatingDesk",
    "datatype": "String",
    "mappingkey": "OriginatingDesk",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Received From MPID",
    "db_columnname": "ReceivedFromMPID",
    "datatype": "String",
    "mappingkey": "ReceivedFromMPID",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Received Order Id",
    "db_columnname": "ReceivedOrderId",
    "datatype": "String",
    "mappingkey": "ReceivedOrderId",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Terminal User",
    "db_columnname": "TerminalUser",
    "datatype": "String",
    "mappingkey": "TerminalUser",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  },
  {
    "display": "true",
    "ui_columnname": "Cancel by Cust.",
    "db_columnname": "CancelbyCust",
    "datatype": "String",
    "mappingkey": "CancelbyCust",
    "dropdown": "NO",
    "disabled": "false",
    "value": "",
    "dropdownvalue": ""
  }
]